import { Text } from '@h2/components/typography/text'
import { Flex } from '@h2/components/layout/flex'
import { guessIcon } from '@h2/features/careerHub/components/careerHubActivity.js'
import { Link } from '@h2/common/components/link'

const ActivityItem = ({ item = {} }) => {
  const ssrItemTypes = ['utl', 'wip', 'sp']

  return (
    <Flex gap="8px" alignItems="center" margin="0 0 5px 0">
      {guessIcon(item.type)}
      <Text size="medium" weight="bold" margin="0">
        <Link href={item.linkUrl} ssr={ssrItemTypes.includes(item.type)}>
          {item.title}
        </Link>
      </Text>
    </Flex>
  )
}

export { ActivityItem }
